import React, { useState, useEffect } from "react";
import Empsidebar from "../components/Empsidebar";
import Empheader from "../components/Empheader";
import Uppercase from "../../admin/components/Uppercase";
import axios from "axios";
import "../../client/pages/Clientdocuments.css";
import { useLocation } from "react-router-dom";
import { useYearContext } from "../../admin/components/YearContext";

function Empclientviewdocs() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const location = useLocation();

  useEffect(() => {
    const { clientEmail } = location.state || {};

    if (clientEmail) {
      fetchClientDocuments(clientEmail);
    }
  }, [location]);

  const [activeTab, setActiveTab] = useState("client");

  const [clientDocuments, setClientDocuments] = useState([]);

  // Handle switching tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const fetchClientDocuments = async (username) => {
    await axios
      .get(`https://api.litaxfilers.com/empclientDocuments/${username}`)

      .then((response) => {
        if (response.data.success) {
          setClientDocuments(response.data.clientDocuments);
          console.log(response.data.clientDocuments);
        } else {
          console.error(
            "Error fetching client documents:",
            response.data.message
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching client documents:", error);
      });
  };

  const handleDownloaddoc = (filePath) => {
    // Replace backslashes with forward slashes in the filePath
    const formattedFilePath = filePath.replace(/\\/g, "/");

    // Construct the download URL based on the formatted filePath
    const downloadUrl = `https://api.litaxfilers.com/${formattedFilePath}`;

    // Create a temporary link
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";

    link.download = formattedFilePath.split("/").pop(); // Set the file name

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click on the link to trigger the download
    link.click();

    // Remove the link from the body
    document.body.removeChild(link);
  };

  const filterDocuments = clientDocuments.filter((doc) => {
    const documentDate = doc.uploaded_on
      ? doc.uploaded_on.substring(0, 10)
      : "";
    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;
    const isYearMatch = documentDate >= startDate && documentDate <= endDate;
    return isYearMatch;
  });

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = filterDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div>
      <Uppercase />
      <div className="client-grid-container">
        <Empheader openSidebar={openSidebar} />
        <Empsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <div>
              <h4>Documents</h4>

              <div>
                <ul
                  className="nav nav-tabs mt-3 doctabs"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <a
                      className={`doclinks nav-link ${
                        activeTab === "client" ? "active" : ""
                      }`}
                      id="home-tab"
                      data-toggle="tab"
                      href="#home"
                      role="tab"
                      aria-controls="home"
                      aria-selected={activeTab === "client"}
                      onClick={() => handleTabChange("client")}
                    >
                      Client Uploaded Documents
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className={`doclinks nav-link ${
                        activeTab === "taxExpert" ? "active" : ""
                      }`}
                      id="profile-tab"
                      data-toggle="tab"
                      href="#profile"
                      role="tab"
                      aria-controls="profile"
                      aria-selected={activeTab === "taxExpert"}
                      onClick={() => handleTabChange("taxExpert")}
                    >
                      Tax Experts Uploaded Documents
                    </a>
                  </li>
                </ul>

                <div className="tab-content" id="myTabContent">
                  {/* Client Uploaded Documents Tab */}
                  <div
                    className={`tab-pane fade ${
                      activeTab === "client" ? "show active" : ""
                    }`}
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th>S.No</th>
                            <th>Document Type</th>
                            <th>Uploaded On</th>
                            <th>Uploaded By</th>
                            <th>Comments</th>
                            <th>Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          {records
                            .filter((document) => document.uploaded_client)
                            .map((document, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{document.type}</td>
                                <td>{document.uploaded_on}</td>
                                <td>{document.uploaded_client}</td>
                                <td>{document.comments}</td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    title="Download PDF"
                                    onClick={() => {
                                      console.log(
                                        "Clicked on download for document:",
                                        document
                                      );
                                      handleDownloaddoc(
                                        document.filePath.trim()
                                      );
                                    }}
                                  >
                                    Download
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Tax Expert Uploaded Documents Tab */}
                  <div
                    className={`tab-pane fade ${
                      activeTab === "taxExpert" ? "show active" : ""
                    }`}
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th>S.No</th>
                            <th>Document Type</th>
                            <th>Uploaded On</th>
                            <th>Uploaded By</th>
                            <th>Comments</th>
                            <th>Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          {records
                            .filter((document) => document.uploaded_employee)
                            .map((document, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{document.type}</td>
                                <td>{document.uploaded_on}</td>
                                <td>{document.uploaded_employee}</td>
                                <td>{document.comments}</td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    title="Download PDF"
                                    onClick={() => {
                                      console.log(
                                        "Clicked on download for document:",
                                        document
                                      );
                                      handleDownloaddoc(
                                        document.filePath.trim()
                                      );
                                    }}
                                  >
                                    Download
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Pagination */}
                <nav className="mt-2">
                  <ul className="pagination">
                    <li className="page-item">
                      <a href="#" className="page-link" onClick={prePage}>
                        Prev
                      </a>
                    </li>
                    {numbers.map((n, i) => (
                      <li
                        className={`page-item ${
                          currentPage === n ? "active" : ""
                        }`}
                        key={i}
                      >
                        <a
                          href="#"
                          className="page-link"
                          onClick={() => changeCpage(n)}
                        >
                          {n}
                        </a>
                      </li>
                    ))}
                    <li className="page-item">
                      <a href="#" className="page-link" onClick={nextPage}>
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Empclientviewdocs;
